import {PersonnelVI} from "./personnel/vi";
import {ApplicationVI} from "./application/vi";
import {TimeKeepingVI} from "./timekeeping/vi";
import {WageVI} from "./wage/vi";
import {AssetVI} from "./asset/vi";

export const HRMVI = {
    contract: "Hợp đồng",
    ...PersonnelVI,
    ...ApplicationVI,
    ...TimeKeepingVI,
    ...WageVI,
    ...AssetVI
}